/**
 * FAQ content for /2026-workshop About tab.
 * Edit questions and answers here.
 */

export interface WorkshopFaqItem {
  id: string;
  question: string;
  answer: string;
  /** When true, expanding shows ask-question UI instead of static answer */
  isAskQuestion?: boolean;
}

export const WORKSHOP_2026_FAQ: WorkshopFaqItem[] = [
  {
    id: 'what-is-workshop',
    question: 'What is an SAA step workshop?',
    answer:
      'A step workshop is a facilitated group that works all 12 steps of SAA together over many months. ' +
      'We meet at the same time each week online via Zoom. The group stays largely stable so we build trust, ' +
      'honesty, and momentum — working the steps in community rather than alone.',
  },
  {
    id: 'who-is-it-for',
    question: 'Who is this workshop for?',
    answer:
      'Anyone with a desire to stop addictive sexual behavior who is willing to work the 12 steps of SAA, can commit to weekly attendance (life happens; we understand), ' +
      'and is comfortable with online meetings — the same foundation as SAA meetings. No prior step work is required. People who have worked some or all ' +
      'of the steps before are also welcome — to complete the steps, work them again, and deepen recovery, or share wisdom.',
  },
  {
    id: 'open-to-everyone',
    question: 'Is this workshop open to everyone?',
    answer:
      'Yes. This workshop welcomes anyone seeking recovery from compulsive sexual acting out — regardless of gender, sexual orientation, gender identity, ' +
      'relationship status, faith, or background. SAA\'s only requirement for membership is a desire to stop addictive sexual behavior. You belong here.',
  },
  {
    id: 'sponsor',
    question: 'Do I need a sponsor?',
    answer:
      'You will need a sponsor to complete Step One. If you do not have one yet, that is okay — part of preparing ' +
      'for the workshop is thinking about sponsorship, and the group can help you consider how to find one.',
  },
  {
    id: 'how-long',
    question: 'How long does the workshop run?',
    answer:
      'There is no fixed number of weeks. Workshops typically run 35–60 weeks, depending on group pace and consensus. ' +
      'We work one step at a time and move when the group is ready.',
  },
  {
    id: 'cost',
    question: 'Is there any cost for the workshop?',
    answer:
      'No. There is no cost to join — the workshop and Recovery Commons are a labor of love, offered freely in the ' +
      'spirit of one addict helping another. There are no fees, dues, or charges to participate.',
  },
  {
    id: 'weekly-session',
    question: 'What happens at each weekly session?',
    answer:
      'Sessions focus on the current step with step-focused reading together, sharing, and encouragement. ' +
      'Between sessions, members learn and record their step work in Recovery Commons while working with their sponsors and others in the program.',
  },
  {
    id: 'registration',
    question: 'How do I register?',
    answer:
      'Go to the Workshop tab above, create a free Recovery Commons account, and indicate your interest. ' +
      'When you are ready to commit, confirm you are planning to attend — then the Zoom link appears on the Workshop tab above before the first session. ' +
      'Missed the first meeting? You can still sign up and join us when you are ready.',
  },
  {
    id: 'time-commitment',
    question: 'What is the weekly time commitment?',
    answer: '',
  },
  {
    id: 'past-workshops',
    question: 'Have you run workshops like this before?',
    answer: '',
  },
  {
    id: 'recovery-commons',
    question: 'What is Recovery Commons and how does it fit in?',
    answer:
      'As the facilitator of these workshops, I have seen how much easier people recover when they have a clear path ' +
      'through the steps, a place to record their work, and a simple way to share with their sponsor between weekly ' +
      'meetings. I built Recovery Commons to capture what we have learned over many years of workshop experience and ' +
      'to give members a structured, private home for their step work.\n\n' +
      'Recovery Commons is a free online tool for your 12-step work — guided actions, inventories, and progress you ' +
      'own. Workshop members use it between sessions to stay on track and optionally share with a sponsor. The workshop ' +
      'itself (Zoom, calendar, phone list) lives on this page under the Workshop tab.',
  },
  {
    id: 'privacy',
    question: 'Is my step work private?',
    answer:
      'Yes. Your sensitive step work in Recovery Commons is encrypted; only you can read it. Workshop facilitators do ' +
      'not and cannot read your private inventories or step writing. Sharing with a sponsor or others is entirely ' +
      'under your control.',
  },
  {
    id: 'ask',
    question: 'Have a question not answered here?',
    answer: '',
    isAskQuestion: true,
  },
];
